import './App.css';
import React, { useEffect } from 'react';
import About from './components/About';
import Brands from './components/Brands';
import Footer from './components/Footer';
import Contact from './components/Contact';
import RealEstate from './components/RealEstate';
import FuturePlans from './components/FuturePlans';
import Header from './components/Header';
import Nav from './components/Nav';
import News from './components/News';
import Upcoming from './components/Upcoming';
import Pipeline from './components/Pipeline';
import Portfolio from './components/Portfolio';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {

  useEffect(() => {
  const hash = window.location.hash;
  if (hash) {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }
}, []);

  return (
    <Router>
      <div className="App">
        <Nav />
          <Routes>
            <Route path="/" element={
              <>
                <Header />
                <About />
                <Portfolio />
                <Pipeline />
                <Upcoming />
                <FuturePlans />
                <News />
                <Brands />
              </>
            } />
            <Route path="/real-estate" element={<RealEstate />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        <Footer />
      </div>
    </Router>
    
  );
}

export default App;
